var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M5.86654 3.19999V2.66666C5.86654 1.48845 6.82166 0.533325 7.99987 0.533325C9.17808 0.533325 10.1332 1.48845 10.1332 2.66666V3.19999M0.533203 12.2667H15.4665M1.59987 3.73333H14.3999C14.989 3.73333 15.4665 4.21089 15.4665 4.79999V14.4C15.4665 14.9891 14.989 15.4667 14.3999 15.4667H1.59987C1.01077 15.4667 0.533203 14.9891 0.533203 14.4V4.79999C0.533203 4.21089 1.01077 3.73333 1.59987 3.73333Z",
      stroke: "#484848"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }